import React from "react";
import { Icon, Row, Col } from "antd";
// Utilities and hooks
import { push } from "helpers/history";
// Shared components
import Button from "components/Button";
// Styles
import styles from "./index.module.scss";

const BuyGoldStepThree: React.FC = () => {
	return (
		<Row className={styles["stepThreeContent"]}>
			<Col span={12} offset={6}>
				<div>
					<h3 style={{ color: "#377459", textAlign: "center", marginBottom: "50px" }}>
						خرید طلا با موفقیت انجام شد و به دارایی شما افزوده گردید.
					</h3>
					<Icon style={{ fontSize: "170px", color: "#377459", display: "block" }} type="check-circle" />
					<div className="button-center">
						<Button onClick={() => push("/dashboard")} primary className="auto-width">
							بازگشت
						</Button>
					</div>
				</div>
			</Col>
		</Row>
	);
};

export default BuyGoldStepThree;
